import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {type InterestRecommendationSignal} from '@dms/api/interest-recommendations';
import i18n from '@dms/i18n';

export function getRecommendationSignalReason(signal: InterestRecommendationSignal) {
  return match(signal.code)
    .with('customerAwaitingReply', 'noFirstResponse', () =>
      isNotNil(signal.evidence.waitingSinceHours)
        ? i18n.t('entity.interestRecommendations.reasons.waitingForReply', {
            defaultValue: 'Hours without a reply: {hours}',
            hours: signal.evidence.waitingSinceHours,
          })
        : undefined
    )
    .with('overdueTask', () =>
      isNotNil(signal.evidence.overdueTaskCount)
        ? i18n.t('entity.interestRecommendations.reasons.overdueTasks', {
            defaultValue: 'Overdue tasks: {count}',
            count: signal.evidence.overdueTaskCount,
          })
        : undefined
    )
    .with('goingCold', () =>
      isNotNil(signal.evidence.inactiveForDays)
        ? i18n.t('entity.interestRecommendations.reasons.inactiveDays', {
            defaultValue: 'Days without customer activity: {days}',
            days: signal.evidence.inactiveForDays,
          })
        : undefined
    )
    .with('missingNextStep', () =>
      i18n.t('entity.interestRecommendations.reasons.missingNextStep', {
        defaultValue: 'No next step is planned for this interest',
      })
    )
    .with('engagementDetected', () => undefined)
    .exhaustive();
}
